/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約使用量
 */
export interface Sgkb575aResCtrEmpamt {
    /** 
     * 契約使用量種別コード：半角英数混在
     */
    ctrEmpamtClscode?: string;
    /** 
     * 契約使用量種別コード名称：全角半角混在
     */
    contractusageClsfyCodeaname?: string;
    /** 
     * 表示順：半角数値(小数点なし)
     */
    hyojiTurn?: number;
    /** 
     * 使用量：半角数値(小数点なし)
     */
    elecCsp?: number;
    /** 
     * 使用量単位コード：半角英数混在
     */
    empamtUnitCode?: string;
    /** 
     * 使用量単位コード名称：全角文字
     */
    enmploymentpositionaimChangeflag?: string;
}
